import { componentNameConstants, dlEventConstants } from "@repo/analytics/data-layer.constants";
import { dataLayer } from "@repo/analytics/data-layer-utils";

/**
 * FooterAppDownloadFunction.ts
 * Analytics handler for Footer App Download button clicks
 */

// Footer analytics constants
const FOOTER_DOWNLOAD_APP = "footer_download_app";
const DOWNLOAD_APP_SECTION_TITLE = "Download App";

// Analytics event handler for Footer App Download click
export function handleFooterAppDownloadClickDL(
  loginStatus: string,
  destination_url: string,
  platform: string,
  cta_text: string
) {
  // Create analytics data object
  const data = {
    component: componentNameConstants.FOOTER_COMPONENT,
    event: dlEventConstants.CLICK,
    event_type: dlEventConstants.BUTTON_CLICK,
    element: FOOTER_DOWNLOAD_APP,
    destination_url: destination_url ?? "",
    cta_text: cta_text ?? "",
    sec_title: DOWNLOAD_APP_SECTION_TITLE,
    platform: platform,
  };

  const cleverTapObj = {
    component: data.component,
    event: data.event,
    event_type: data.event_type,
    element: data.element,
    destination_url: data.destination_url,
    cta_text: data.cta_text,
    sec_title: data.sec_title,
    platform: data.platform,
  };

  // Send to data layer
  dataLayer(loginStatus, data, cleverTapObj);
}
